function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object, String, searchFilter, searchInputEl, secondaryAction) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": {
          'mp-context-menu-wrapper': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "hook": {
            insert: $helpers.inserted
          },
          "class": {
            'mp-context-menu': true
          },
        }, (function() {
          var __jade_nodes = []; /*  because mp-context-menu is a hack that yanks .mp-context-menu to body level */
          __jade_nodes = __jade_nodes.concat(h("style", [__vjadeSafeCode($helpers.getCss())]));
          __jade_nodes = __jade_nodes.concat(h("mp-drop-menu", {
            "attrs": __vjadeStringifyAttrsIfObj({
              open: $attr(`open`),
              'prevent-close-selectors': JSON.stringify([`mp-context-panel-internal`]),
            }),
            "on": {
              change: $helpers.handleDropMenuChange,
              click: ev => ev.stopPropagation(),
            },
            "style": {
              left: `${$attr(`position`).left}px`,
              top: `${$attr(`position`).top}px`,
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((((secondaryAction) == (`breakdown`))) ?
              ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'context-menu-search-wrapper': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-input", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      icon: `search`,
                      placeholder: `Search`,
                      value: searchFilter,
                    }),
                    "on": {
                      input: $helpers.handleSearchInput
                    },
                    "hook": {
                      insert: $helpers.searchInputInserted
                    },
                  }));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("mp-properties-menu", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    'disabled-items': JSON.stringify($helpers.breakdownDisabledItemsMap()),
                    'event-names': JSON.stringify([$attr(`source-node`).event]),
                    'open': $attr(`open`),
                    'project-id': $attr(`project-id`),
                    'workspace-id': $attr(`workspace-id`),
                    'search-filter': searchFilter,
                    'include-custom-properties': `all`,
                    'description-edit-disabled': true,
                  }),
                  "on": {
                    select: $helpers.handleBreakdownMenuSelect,
                  },
                  "props": {
                    keydownProxyEl: searchInputEl,
                  },
                }));;
                return __jade_nodes
              }).call(this)) :
              ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    sections: JSON.stringify([{
                      items: $helpers.menuItems()
                    }])
                  }),
                  "on": {
                    click: ev => ev.stopPropagation(),
                    clickItem: $helpers.handleContextMenuSelect,
                  },
                  "class": {
                    'context-menu-options': true
                  },
                }));;
                return __jade_nodes
              }).call(this)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "searchFilter" in locals ? locals.searchFilter : typeof searchFilter !== "undefined" ? searchFilter : undefined, "searchInputEl" in locals ? locals.searchInputEl : typeof searchInputEl !== "undefined" ? searchInputEl : undefined, "secondaryAction" in locals ? locals.secondaryAction : typeof secondaryAction !== "undefined" ? secondaryAction : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;